import gql from 'graphql-tag';
import React from 'react';
import { useQuery } from 'react-apollo';
import { AuthContext } from '../../AuthService';

const query = gql`
  query VenuesQuery {
    venues {
      id
      name
    }
  }
`;

export const Home = ({ history }) => {
  const auth = React.useContext(AuthContext);
  const { loading } = useQuery(query, {
    onCompleted(data) {
      history.push(`/venue/${data.venues[0].id}/dashboard`);
    },
    onError() {
      auth.logout();
      history.push('/');
    },
  });

  return loading ? <span>Loading...</span> : <span>Signing in...</span>;
};
